<template>
  <div :class="messageWrapperClass">
    <div :class="messageContentClass" v-html="message.role === 'user' ? message.content : marked(message.content)" />
  </div>
</template>

<script setup>
import { computed } from "vue";
import { marked } from "marked";

const props = defineProps({
  message: {
    type: Object,
    required: true,
  },
});

const messageWrapperClass = computed(() => ["d--f mt-8px mb-8px", props.message.role === "user" ? "jc--fe" : "jc--fs"]);

const messageContentClass = computed(() => [
  "message pa-10px br-10px font-14px",
  props.message.role === "user" ? "bg-green-2 text-white" : "bg-grey-12 markdown-content",
]);
</script>

<style lang="scss" scoped>
.message {
  max-width: 80%;
  word-break: break-word;
}

:deep(.markdown-content) {
  p {
    margin: 0.5em 0;
  }
  ul,
  ol {
    margin: 0.5em 0;
    padding-left: 1.5em;
  }
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin: 0.5em 0;
  }
  code {
    background: rgba(0, 0, 0, 0.05);
    padding: 0.2em 0.4em;
    border-radius: 3px;
    font-size: 0.9em;
  }
  pre {
    background: rgba(0, 0, 0, 0.05);
    padding: 0.5em;
    border-radius: 5px;
    overflow-x: auto;
  }
}
</style>
